import { FormEvent, useEffect, useState } from "react";
import { useHistory } from "react-router";
import { Input } from "reactstrap";
import { InformacoesPessoais } from "../components/InformacoesPessoais";
import { Questionario } from "../components/Questionario";
import { useAuth } from "../hooks/useAuth";
import { instituicao } from "../params";
import { database } from "../services/firebase";

export function CheckinEvento() {
    const history = useHistory();
    //const { user } = useAuth();
    const [user, setUser] = useState<{ id: string; alunoFDV: boolean; email: string; escolaridade: string; nome: string; telefone: string }>();
    const [email, setEmail] = useState("");
    const [submitted, setSubmitted] = useState(false);
    const [showMessage, setShowMessage] = useState(false);

    useEffect(() => {
        if (user === undefined || user.id === undefined) {
            return;
        }

        const fullDate = new Date().toISOString().substr(0, 10);

        database
            .ref(`questionarios/${fullDate}`)
            .orderByChild("nome")
            .equalTo(user.nome)
            .once("child_added", function (snapshot) {
                const data: { liberado: boolean } = snapshot.val();

                if (data !== null) {
                    if (data.liberado) {
                        history.push(`/acesso-autorizado/${fullDate}/${snapshot.key}`);
                    } else {
                        history.push(`/acesso-negado/${fullDate}/${snapshot.key}`);
                    }
                }
            });
    }, [user?.id]);

    /* Simplify error check */
    function hasError(formName: string, inputName: string, method: string): boolean {
        return false;
        /*return  this.state[formName] &&
                this.state[formName].errors &&
                this.state[formName].errors[inputName] &&
                this.state[formName].errors[inputName][method]*/
    }

    async function handleEmail(event: FormEvent) {
        event.preventDefault();

        let result = false;
        console.log(email);
        await database
            .ref(`eventos/-Mj_F46hq1zarDttZbz2/inscricoes`)
            .orderByChild("email")
            .equalTo(email.toLowerCase())
            .once("value", function (snapshot) {
                console.log(snapshot);
                snapshot.forEach((instance) => {
                    const data: { alunoFDV: boolean; email: string; escolaridade: string; nome: string; telefone: string } = instance.val();

                    if (null !== data) {
                        localStorage.setItem("logado", "sim");
                        console.log(data);
                        setUser({
                            id: instance.key || "",
                            alunoFDV: data.alunoFDV,
                            email: data.email,
                            escolaridade: data.escolaridade,
                            nome: data.nome,
                            telefone: data.telefone,
                        });

                        result = true;
                        setSubmitted(true);
                    }
                });
            });

        if (!result) {
            setEmail("");
            setShowMessage(true);
        }
    }

    if (email !== "" && submitted) {
        return (
            <div className="content-wrapper">
                <div className="content-heading">
                    <div>Checkin de Participante</div>
                </div>

                <InformacoesPessoais user={user} />

                <div className="row">
                    <div className="col-md-6">
                        <div className="card card-default">
                            <div className="card-header">
                                <strong>QUESTIONÁRIO AUTODECLARATÓRIO DE SAÚDE</strong>
                            </div>
                            <div className="card-body">
                                <Questionario user={user}></Questionario>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    } else {
        return (
            <div className="block-center mt-4 wd-xl">
                <div className="card card-flat">
                    <div className="card-body">
                        <p className="text-center py-2">Check-in de evento</p>
                        <form className="mb-3" name="formEmail" onSubmit={handleEmail}>
                            {showMessage && <div className="alert alert-primary">E-mail não cadastrado</div>}
                            <div className="form-group">
                                <div className="input-group with-focus">
                                    <Input
                                        type="text"
                                        id="email"
                                        name="email"
                                        className="border-right-0"
                                        placeholder="Digite o seu e-mail"
                                        invalid={hasError("formEmail", "email", "required")}
                                        onChange={(event) => {
                                            setEmail(event.target.value);
                                        }}
                                        data-validate='["required"]'
                                        defaultValue={email}
                                    />
                                    <div className="input-group-append">
                                        <span className="input-group-text text-muted bg-transparent border-left-0">
                                            <em className="far fa-envelope"></em>
                                        </span>
                                    </div>
                                    {hasError("formEmail", "email", "required") && <span className="invalid-feedback">Field is required</span>}
                                    {hasError("formEmail", "email", "email") && <span className="invalid-feedback">Field must be valid email</span>}
                                </div>
                            </div>
                            <button className="btn btn-block btn-primary mt-3" type="submit">
                                Entrar
                            </button>
                        </form>
                    </div>
                </div>
                <div className="p-3 text-center">
                    <span className="mr-2">&copy;</span>
                    <span>2021</span>
                    <span className="mx-2">-</span>
                    <span>Case Tecnologia</span>
                </div>
            </div>
        );
    }
}
